module.exports = __webpack_public_path__ + "img/feature-item-03.e99a1fac.png";